import React from 'react'
import aboutuskoffeehouse from "../images/about us _koffee.jpeg";

function About() {
  return (
    <div>
               <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
 <h1 className='mb-2 justify'>About <b style={{color:"#3D2219"}}> Koffee House</b></h1>
    <p className="card-text justify">Welcome to <b> Koffee House</b>, a popular family restaurant in Krishnagar, Nadia, known for serving delicious, hygienic, and freshly prepared food in a comfortable and friendly environment. We are proud to be one of the best restaurants in Krishnagar where families, friends, and food lovers come together to enjoy quality meals and great service.</p>
    <p className='justify'>At Koffee House, our goal is to provide a perfect dining experience with a wide range of tasty dishes prepared using high-quality ingredients and strict hygiene standards. Our menu offers a variety of Indian food, Chinese cuisine, fast food, snacks, coffee, and beverages, making us a favorite restaurant and coffee spot in Krishnagar for people of all ages.</p>
<p className='justify'>Whether you are planning a family dinner, casual meet-up, birthday celebration, or coffee break, Koffee House provides a warm and welcoming atmosphere for every occasion. Our dedicated team focuses on maintaining cleanliness, quality, and excellent customer service, ensuring that every guest enjoys a memorable dining experience.</p>
<p className='justify'>Located in Krishnagar, Nadia, West Bengal, Koffee House has become a trusted name for hygienic food, delicious taste, and affordable dining. We continuously strive to deliver the best flavors and hospitality to our customers.</p>
                </div>
                  <div className="col-md-6 mt-3">
  <img src={aboutuskoffeehouse} className="card-img-top" alt="aboutuskoffeehouse"/>

                </div>
                </div>
                </div>
                
            
            </div>
    </div>
  )
}

export default About